export default "__VITE_ASSET__B6ywl_xo__"